<template>
  <v-card class="mt-4 mx-2 cardStyle" v-if="job !== undefined">
    <v-card-text>
      <div class="text-body-1 font-weight-bold teal--text">
        <v-badge :content="job.assignedAgents.length">
          Assigned Agent(s)
        </v-badge>
      </div>
      <v-list dense style="max-height: 30vh; overflow-y: scroll;">
        <v-list-item dense v-for="(agent, i) in job.assignedAgents" :key="i">
          <v-list-item-content class="ml-n4">
            <v-list-item-title>{{ agentName(agent) }}</v-list-item-title>
            <v-list-item-subtitle>{{ agent.agent_code }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-chip label :color="agent.status === 'Active' ? 'green lighten-1' : 'blue lighten-1'">{{ agent.status
              }}</v-chip>
          </v-list-item-action>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
      <div class="text-h6"> Reassign Agent </div>
      <v-form class="mt-2" v-model="isValid" ref="imageForm">
        <v-select clearable filled chips label="Select Agent" :items="agents" item-text="name" item-value="code"
          v-model="reassignedFormData.agent_code" :rules="rules">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item ripple v-on="on" v-bind="attrs">
              <v-list-item-avatar color="teal lighten-4" class="teal--text text--darken-4">
                {{ item.code }}
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <span>{{ item.name }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ item.phone_no }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" class="btnActions" block @click="reassignJobCard(job)">
        Reassign
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style>
@import url('../styles.css');
</style>
<script>
import { base64ToUnicode } from '../../../../../cetus-base/utilities/helpers/base64-to-unicode'
import RepoMethods from '../RepoMethods'
export default {
  name: 'Reassign',
  data: function () {
    return {
      isValid: false,
      reassigned: '',
      rules: [
        v => !!v || 'Field is required'
      ],
      reassignedFormData: {
        agent_code: ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next((v) => {
      const { jobCode } = v.$route.params
      v.$store.dispatch('reposession/updatePrevRoute', from)
      v.getJob(base64ToUnicode(jobCode))
    })
  },
  computed: {
    agents: function () {
      return this.$store.getters['reposession/getAgents']({ job: this.job, coordinator: this.$store.getters['auth/user'] })
    },
    job: function () {
      return this.$store.getters['reposession/getJobObject']()
    }
  },
  methods: {
    ...RepoMethods
  }
}
</script>
